import React from 'react';
import { get, includes, replace } from 'lodash';
import { string } from 'prop-types';
import { FlexContainer, Button, HasPermissions } from '../../common';

const DownloadChangeTicket = ({ urlChangeTicket, origin, ...props }) => {
    const status = get(props, 'assignInfo.status.code', '1');
    const validStatuses = ['5', '50', '51', '53', '54', '55', '56', '57', '58', '59', '60'];
    const disabled = !urlChangeTicket || urlChangeTicket.search('http') === -1;
    if (disabled) return null;
    if (!includes(validStatuses, status)) return null;
    return (
        <HasPermissions to={['order-detail-page:download-change-ticket ']}>
            <FlexContainer flex='1' justify='center' align='flex-end'>
                <FlexContainer>
                    <Button
                        link
                        text={'Ticket de cambio'}
                        onClick={() => window.open(replace(urlChangeTicket, 'down=true', ''))}
                        className='sisaButton'
                    />
                </FlexContainer>
            </FlexContainer>
        </HasPermissions>
    );
};

DownloadChangeTicket.propTypes = {
    url: string,
    origin: string
};

export default DownloadChangeTicket;
